import { InjectionToken } from '@angular/core';
import { AgeRate, ContentType, LocalizedData, LocalizedString, PreviewOverlayParentLocalizedGenre, Url } from '../../../common';
import { ImgQuery } from '../../services';
import { ContentViewModel } from '../carousel-item/content-view.model';

export interface PreviewOverlayParentViewModel {
  id: string;
  seriesTitle?: string;
  title: string;
  titleEn: string;
  guid: string;
  description: string;
  descriptionLocalized: LocalizedString;
  releaseYear: number;
  ageRate: AgeRate;
  previewThumbnailUrl: Url;
  titleTreatmentUrl: Url;
  videoUrl: Url;
  trailerUrl: Url | undefined;
  videoId: string;
  genres: PreviewOverlayParentLocalizedGenre[];
  isArabicContentType: boolean;
  routerLink: string;
  imgQuery?: ImgQuery;
  categoryTitle?: string; // for analytics
  playMediaOnClick?: boolean;
  portraitLayout?: boolean;
  recentSeason?: number;
  recentEpisode?: number;
  itemGuid: string;
}

export interface PreviewOverlayMovieViewModel extends PreviewOverlayParentViewModel {
  type: 'movie';
  lengthInSeconds: number;
  elapsedInSeconds: number;
}

export interface PreviewOverlayEpisodeViewModel extends PreviewOverlayParentViewModel {
  type: 'episode';
  lengthInSeconds: number;
  elapsedInSeconds: number;
  season: number;
  episodeNumber: number;
  episodeTitle?: string;
  seriesGuid: string;
  seasonId: string;
  seriesTitleEn: string;
}

export interface PreviewOverlaySeriesViewModel extends PreviewOverlayParentViewModel {
  type: 'series';
  numberOfSeasons: number;
}

export interface PreviewOverlaySeasonViewModel extends PreviewOverlayParentViewModel {
  type: 'season';
  numberOfEpisodes: number;
  seriesGuid: string;
  seasonId: string;
}

export type PreviewOverlayViewModel =
  | PreviewOverlayMovieViewModel
  | PreviewOverlayEpisodeViewModel
  | PreviewOverlaySeriesViewModel
  | PreviewOverlaySeasonViewModel;

export interface ShallowPreviewOverlayViewModel {
  type: ContentType;
  guid: string;
  title: LocalizedData<string>;

  content: ContentViewModel;

  imgQuery: ImgQuery;
}

export interface ClosableOverlay {
  setPreviewHoverState: (obj: { isMouseOver: boolean }) => void;
  onOverlayDestroyed(): void;
}

export interface PreviewOverlaySource {
  notifyOverlayClosed();
}

// eslint-disable-next-line @typescript-eslint/naming-convention,no-underscore-dangle,id-blacklist,id-match
export const PreviewOverlayViewModelToken = new InjectionToken<ShallowPreviewOverlayViewModel>('PreviewOverlayViewModel');

// eslint-disable-next-line @typescript-eslint/naming-convention, no-underscore-dangle, id-blacklist, id-match
export const ClosableOverlayToken = new InjectionToken<ClosableOverlay>('ClosableOverlay');
